import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Routes, Route, Navigate } from 'react-router-dom'
import { PrivateLayoutComponent } from '../../ui'
import { setUserData } from '../../features/profile/slices'
import { getRoutes } from './private.utils'

export const PrivateRouter = () => {
  const dispatch = useDispatch()
  const global = useSelector((state) => state.global)

  useEffect(() => {
    if (global.userId) dispatch(setUserData(global.userId, global.accessToken))
  }, [global.userId])

  const router = useMemo(() => {
    return getRoutes(global.role, global.permissions)
  }, [global])

  // --- AÑADE ESTA LÍNEA PARA DEPURAR ---
  console.log('Rutas generadas para el router:', router.routes)

  return (
    <PrivateLayoutComponent {...{ userRole: global.role, userPermissions: global.permissions }}>
      <Routes>
        {router.routes.map((route) => {
          const Component = route.component
          return <Route key={route.path} path={route.path} element={<Component />} />
        })}
        <Route path="*" element={<Navigate to={router.redirect} />} />
      </Routes>
    </PrivateLayoutComponent>
  )
}
